import { useEffect } from "react";

import CloseModalIcon from "../../shared-components/icons/CloseModalIcon";
import { useManagementSubscriptionContext } from "./Context";
import Step1 from "./step1";
import Step2 from "./step2";
import Step3 from "./step3";
import Step4 from "./step4";

const CancelPopupSubscription = () => {
  const { cancelProcessActiveStep, onCancelSubscriptionModal } = useManagementSubscriptionContext();

  useEffect(() => {
    document.querySelector("body").classList.add("overflow-hidden");
    return () => {
      document.querySelector("body").classList.remove("overflow-hidden");
    };
  }, []);

  return (
    <div>
      <div data-name="Overlay" className="fixed inset-0 z-[9999] bg-black/80"></div>
      <div
        data-name="PopupContainer"
        className={"fixed inset-0 z-[99999] w-full min-h-full overflow-x-hidden overflow-y-auto"}>
        <div className={"w-full min-h-full flex-center flex-col m-auto"}>
          <div
            className={
              "bg-white relative w-full lg:max-w-[1000px] lg:min-h-[614px] px-4 pt-10 pb-3 lg:px-14 lg:pb-6 flex flex-col max-lg:grow lg:rounded-lg"
            }>
            <button onClick={onCancelSubscriptionModal} className={"absolute right-3 top-3"}>
              <CloseModalIcon className={"size-6 text-gray-5"} />
            </button>
            {cancelProcessActiveStep === 1 && <Step1 />}
            {cancelProcessActiveStep === 2 && <Step2 />}
            {cancelProcessActiveStep === 3 && <Step3 />}
            {cancelProcessActiveStep === 4 && <Step4 />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CancelPopupSubscription;
